import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const Row = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 0px 13px 0;
  padding-inline-start: 15px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  background: ${COLORS.primaryExtraLight};
  transition: all 0.3s;

  &:hover {
    background: ${({ $disabled }) =>
      $disabled ? COLORS.primaryExtraLight : COLORS.primaryLight};

    p {
      color: ${({ $disabled }) =>
        $disabled ? COLORS.secondarySemiDark : COLORS.secondaryDark};
    }
  }
`
